import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-4" data-id="element-33" data-mp="1hcrwc7ansus8">
      <div className="mx-auto max-w-3xl" data-id="element-34" data-mp="1hduloasc2p61">
        <h2 className="mb-2 text-center font-display text-2xl uppercase leading-none tracking-wide sm:text-4xl" data-id="element-35" data-mp="1cf05zhpnxgq5">
          Frequently Asked Questions
        </h2>
        <div className="space-y-1.5" data-id="element-36" data-mp="2a05vmc1ty2fi">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <article key={faq.question} className="overflow-hidden rounded-lg border border-brand-line bg-brand-light" data-id="element-37" data-mp="2065j3p47xuwr" data-mpi={index}>
                <h3 data-id="element-38" data-mp="opozdjlmss43">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left" aria-expanded={isOpen} aria-controls={panelId} data-id="element-39" data-mp="oq72n06po6li">
                    <span className="font-head text-[13px] font-semibold leading-snug text-brand-navy sm:text-base" data-id="element-40" data-mp="1aq2b3ri9kg2u">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-gold transition-transform duration-150 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-41" data-mp="11x8sbk3lyyk8" />
                  </button>
                </h3>
                {isOpen && <p id={panelId} className="px-3 pb-2.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-42" data-mp="wyfe1pghz3j0">
                    {faq.answer}
                  </p>}
              </article>;
        })}
        </div>
      </div>
    </section>;
}